import React from 'react';
import ReactECharts from 'echarts-for-react';

export default function PlanetChart() {
  const option = {
    backgroundColor: 'transparent',
    tooltip: { 
      trigger: 'item', 
      backgroundColor: 'rgba(3, 18, 17, 0.95)', 
      borderColor: 'rgba(0, 240, 255, 0.2)', 
      textStyle: { color: '#fff', fontFamily: 'Space Grotesk' },
      padding: [12, 16],
      formatter: '{b} <br/> <span style="color:#D4AF37; font-family: Space Mono">${c}</span> ({d}%)'
    },
    series: [
      {
        name: 'Sector Allocation',
        type: 'pie',
        radius: ['58%', '85%'],
        center: ['50%', '50%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 6,
          borderColor: '#081F1D', 
          borderWidth: 6
        },
        label: { show: false },
        emphasis: {
          label: {
            show: true,
            fontSize: 14,
            fontWeight: 'bold',
            color: '#fff',
            fontFamily: 'Space Grotesk',
            formatter: '{b}\n{d}%'
          },
          itemStyle: {
            shadowBlur: 20,
            shadowOffsetX: 0,
            shadowColor: 'rgba(255, 255, 255, 0.2)'
          }
        },
        data: [
          { value: 1500, name: 'Habitat Lease', itemStyle: { color: '#00F0FF', shadowBlur: 15, shadowColor: 'rgba(0, 240, 255, 0.3)' } },
          { value: 450, name: 'Sustenance', itemStyle: { color: '#D4AF37', shadowBlur: 15, shadowColor: 'rgba(212, 175, 55, 0.3)' } },
          { value: 180, name: 'Utilities', itemStyle: { color: '#34D399' } },
          { value: 125, name: 'Transport', itemStyle: { color: '#F59E0B' } },
          { value: 80, name: 'Recreation', itemStyle: { color: '#A78BFA' } }
        ]
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '100%', width: '100%' }} />;
}